import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../api/api";
import { login_url, logout_url } from "../api/urls";
// import { useDispatch } from "react-redux";
// import { useDispatch } from "react-redux";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post(login_url, credentials);
      // dispatch(updateProfileImage(response.data.profile_image));
      // console.log("Login API user:", response.data.user);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token = state.auth.accessToken;

      const response = await api.get(logout_url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  accessToken: "",
  refreshToken: "",
  alphaTwoCode: "",
  isAuthModalOpen: false,
  phone: null,
  defaultPincode: "",
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState: (state) => {
      state.user = null;
      state.token = null;
      state.accessToken = null;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    handleAlphaTwoCode: (state, action) => {
      state.alphaTwoCode = action.payload;
      localStorage.setItem("alpha_code", action.payload);
    },
    handleAuthModal: (state, action) => {
      state.isAuthModalOpen = action.payload;
    },
    updateProfileImage: (state, action) => {
      if (state.user) {
        state.user.profile_image = action.payload;
      }
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setDefaultDeliveryPincode: (state, action) => {
      state.defaultPincode = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.accessToken = action.payload.token.access;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.accessToken = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearAuthState,
  setAccessToken,
  handleAlphaTwoCode,
  handleAuthModal,
  setPhone,
  updateProfileImage,
  setDefaultDeliveryPincode,
} = AuthSlice.actions;
export default AuthSlice.reducer;
